var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.component,{tag:"component",attrs:{"meta":_vm.resolvedMeta,"value":_vm.value}})
}
var staticRenderFns = []

export { render, staticRenderFns }